<script lang="ts">
  import { observe } from "$lib/actions/observe";

  let { sectionLabel = "", headline = "", items = [] as Array<{ question: string; answer: string }> } = $props();

  // FAQPage structured data for rich results.
  let faqJsonLd = $derived({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer }
    }))
  });
</script>

<svelte:head>
  {#if items.length}
    {@html '<script type="application/ld+json">' + JSON.stringify(faqJsonLd) + "</scr" + "ipt>"}
  {/if}
</svelte:head>

<section>
  <div class="container" style="max-width:720px">
    <div class="section-divider fade-up" use:observe>
      {#if sectionLabel}
        <span class="section-label">{sectionLabel}</span>
      {/if}
      <h2>{headline}</h2>
    </div>
    <div class="fade-up" use:observe>
      <!-- details/summary: answers ship in the prerendered HTML (SEO, agents) and toggle without JS. -->
      {#each items as item}
        <details class="card faq-item">
          <summary>
            <h3>{item.question}</h3>
            <span class="faq-icon" aria-hidden="true">+</span>
          </summary>
          <p>{item.answer}</p>
        </details>
      {/each}
    </div>
  </div>
</section>

<style>
  .faq-item {
    margin-bottom: 8px;
    padding: 1rem 1.5rem;
    background: var(--surface);
  }
  summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    cursor: pointer;
    list-style: none;
  }
  summary::-webkit-details-marker {
    display: none;
  }
  h3 {
    font-size: 1rem;
    margin: 0;
  }
  .faq-icon {
    font-size: 1.25rem;
    color: var(--accent);
    transition: transform 0.3s;
  }
  details[open] .faq-icon {
    transform: rotate(45deg);
  }
  p {
    margin-top: 12px;
    font-size: 0.9rem;
    color: var(--muted);
  }
</style>
